import { Elements } from '@kontent-ai/delivery-sdk'
import {
	DomHtmlNode,
	DomNode,
	parseHTML,
	toHTML,
	transformToPortableText,
} from '@kontent-ai/rich-text-resolver'
import { ReactNode } from 'react'
import slugify from 'slugify'
const Heading = ({
	as,
	id,
	children,
}: {
	as: string
	id: string
	children: ReactNode
}) => {
	const Tag = as as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	return <Tag id={id}>{children}</Tag>
}

export const getRichtextElementHeadingsReact = (
	richTextElement: Elements.RichTextElement,
): JSX.Element[] => {
	const portableText = transformToPortableText(richTextElement.value)
	const html = toHTML(portableText)

	return parseHTML(html)
		.map((item: DomNode) => {
			const isHeading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(
				item['tagName'],
			)
			if (item.type === 'tag' && isHeading) {
				const _item: DomHtmlNode = item
				console.log(_item.children)

				const firstChild = _item.children?.[0]
				const id = slugify(
					firstChild?.['content'] as unknown as string,
					{ lower: true },
				)

				return (
					<Heading
						as={_item.tagName}
						id={id || ''}
						{..._item.attributes}
					>
						{_item.children.map((child) => {
							return child.type === 'text' ? child.content : null
						})}
					</Heading>
				)
			}
			return null
		})
		.filter(Boolean)
}
